import Vue from "vue";
import Router from "vue-router";
import { constants } from "@/lib/constants";
import { trackAnalyticsEvent } from "@/lib/utilities";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: constants.APP_BASE,
  routes: [
    {
      path: "/Home",
      name: "Home",
      meta: { title: "Home" },
      component: () => import("@/views/Home")
    },
    {
      path: "/About",
      name: "About",
      meta: { title: "About" },
      component: () => import("@/views/About")
    },
    {
      path: "/Events",
      name: "Events",
      meta: { title: "Events" },
      component: () => import("@/views/Events")
    },
    {
      path: "/Temple",
      name: "Temple",
      meta: { title: "Temple" },
      component: () => import("@/views/Temple")
    },
    {
      path: "/Society",
      name: "Society",
      meta: { title: "Society" },
      component: () => import("@/views/Society")
    },
    {
      path: "/Gaushaala",
      name: "Gaushaala",
      meta: { title: "Gaushaala" },
      component: () => import("@/views/Gaushaala")
    },
    {
      path: "/Gallery",
      name: "Gallery",
      meta: { title: "Gallery" },
      component: () => import("@/views/Gallery")
    },
    {
      path: "/Contact",
      name: "Contact",
      meta: { title: "Contact" },
      component: () => import("@/views/Contact")
    },
    {
      path: "/News",
      name: "News",
      meta: { title: "News" },
      component: () => import("@/views/NewsDetails")
    },
    {
      path: "/PanchKalyanak",
      name: "PanchKalyanak",
      meta: { title: "Panchkalyanak" },
      component: () => import("@/views/Panchkalyanak")
    },
    {
      path: "/PanchKalyanak/UserSearch",
      name: "UserSearch",
      meta: { title: "Users" },
      component: () => import("@/views/UserSearch")
    },
    {
      path: "/PanchKalyanak/Report",
      name: "Report",
      meta: { title: "User Search" },
      component: () => import("@/views/Report")
    },
    {
      path: "/PanchKalyanak/Reg",
      name: "Reg",
      meta: { title: "Report" },
      component: () => import("@/views/Reg")
    },
    {
      path: "/PanchKalyanak/PushpBrashtiReg",
      name: "PushpBrashtiReg",
      meta: { title: "Pushpbrashti Registration" },
      component: () => import("@/views/PushpBrashtiReg")
    },
    {
      path: "/PanchKalyanak/PushpBrashtiReport",
      name: "PushpBrashtiReport",
      meta: { title: "Pushpbrashti Report" },
      component: () => import("@/views/PushpBrashtiReport")
    },
    {
      path: "/PanchKalyanak/Contacts",
      name: "Contacts",
      meta: { title: "Registration" },
      component: () => import("@/views/Contacts")
    },
    {
      path: "/PanchKalyanak/Faq",
      name: "Faq",
      meta: { title: "Contacts" },
      component: () => import("@/views/Faq")
    },
    {
      path: "/PanchKalyanak/Admin",
      name: "Admin",
      meta: { title: "FAQ" },
      component: () => import("@/views/Admin")
    },
    {
      path: "/PanchKalyanak/Inventory",
      name: "Inventory",
      meta: { title: "Admin" },
      component: () => import("@/views/Inventory")
    },
    {
      path: "/PanchKalyanak/StayAllocation",
      name: "StayAllocation",
      meta: { title: "Inventory" },
      component: () => import("@/views/StayAllocation")
    },
    {
      path: "/PanchKalyanak/PaymentStatus",
      name: "PaymentStatus",
      meta: { title: "Stay Allocation" },
      component: () => import("@/views/PaymentStatus")
    },
    {
      path: "*",
      redirect: "/Home",
      meta: { title: "Home" },
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (window.location.hostname !== "localhost") {
    //redirectIfNotLoggedIn(next, `/${constants.APP_BASE}`, true);
    next();
  } else {
    next();
  }
});

router.afterEach(to => {
  const routeTitle = (to.meta && to.meta.title) || to.name || "Page";
  document.title = routeTitle;
  trackAnalyticsEvent("page_view", {
    page_path: to.fullPath,
    page_title: routeTitle
  });
});

// error handler:
router.onError(() => {
  // the build for production does not allow console logs ....
  // console.error("Handling this error", err.message);
});

export default router;
